import VesselColour from "../../Enums/VesselColour";

const VesselTypeCategory = {
	BULK_CARRIER: "Bulk Carrier",
	CHEMICAL_TANKER: "Chemical Tanker",
	COMBINATION_CARRIER: "Combination Carrier",
	CONTAINER_SHIP: "Container Ship",
	GENERAL_DRY_CARGO: "General Dry Cargo",
	LIVESTOCK: "Livestock",
	LNG_CARRIER: "LNG Carrier",
	MISCELLANEOUS: "Miscellaneous",
	OFFSHORE: "Offshore",
	PASSENGER_SHIP: "Passenger Ship",
	PURE_CAR_CARRIER: "Pure Car Carrier",
	REEFER: "Reefer",
	ROLLON_ROLLOFF: "Roll-on Roll-off",
	TANKER: "Tanker"
};
const VesselTypeCategoryMeta = {
	[VesselTypeCategory.BULK_CARRIER]: {
		name: VesselTypeCategory.BULK_CARRIER,
		shortname: "Bulk Crr.",
		color: VesselColour.BROWN,
		contains: [
			"Bulk Carrier",
			"Wood Chip Carrier",
			"Ore Carrier",
			"Lumber Carrier",
			"Log Carrier",
			"Limestone Carrier",
			"Coal",
			"Cargo",
			"Cement Carrier",
			"Bulk/Caustic Soda Carrier (CABU)"
		]
	},
	[VesselTypeCategory.CHEMICAL_TANKER]: {
		name: VesselTypeCategory.CHEMICAL_TANKER,
		shortname: "Chemical Tkr.",
		color: VesselColour.DARKBLUE,
		contains: [
			"Chemical Tanker",
			"Molten Sulphur Carrier",
			"Caustic Soda Carrier",
			"Asphalt-Bitumen Carrier",
			"Asphalt Carrier",
			"Acid Carrier"
		]
	},
	[VesselTypeCategory.COMBINATION_CARRIER]: {
		name: VesselTypeCategory.COMBINATION_CARRIER,
		shortname: "Comb. Crr.",
		color: VesselColour.DARKGREEN,
		contains: [
			"Combination Carrier",
			"Ore/Oil Carrier",
			"Ore/Bulk/Oil Carrier"
		]
	},
	[VesselTypeCategory.CONTAINER_SHIP]: {
		name: VesselTypeCategory.CONTAINER_SHIP,
		shortname: "Container",
		color: VesselColour.DARKRED,
		contains: [
			"Container Ship",
			"Container Reefer"
		]
	},
	[VesselTypeCategory.GENERAL_DRY_CARGO]: {
		name: VesselTypeCategory.GENERAL_DRY_CARGO,
		shortname: "GDC",
		color: VesselColour.GRAY,
		contains: [
			"General Dry Cargo",
			"Wood Pulp",
			"Tween Decker",
			"Stone Carrier",
			"Self Discharging",
			"Sea River Type",
			"Pallet Carrier",
			"Nuclear Fuel Carrier",
			"Multi-purpose Carrier",
			"Logs",
			"Heavy Lift - Semi Submersible",
			"Heavy Lift",
			"General Cargo RoRo",
			"Deck-Cargo",
			"Bitumen Carrier",
			"Aggregates Carrier"
		]
	},
	[VesselTypeCategory.LIVESTOCK]: {
		name: VesselTypeCategory.LIVESTOCK,
		shortname: "Livestock",
		color: VesselColour.LIGHTBLUE,
		contains: [
			"Livestock"
		]
	},
	[VesselTypeCategory.LNG_CARRIER]: {
		name: VesselTypeCategory.LNG_CARRIER,
		shortname: "LNG Crr.",
		color: VesselColour.LIGHTGREEN,
		contains: [
			"LNG Carrier",
			"Regasification Vessel",
			"LNG Bunker",
			"FSU",
			"Floating Storage & Regasification Unit",
			"FLNG",
			"Compressed Natural Gas",
			"Very Large Ethane Carrier",
			"Pressurised/Refrigerated LPG Carrier",
			"Fully Refrigerated LPG Carrier",
			"Fully Pressurised LPG Carrier"
		]
	},
	[VesselTypeCategory.MISCELLANEOUS]: {
		name: VesselTypeCategory.MISCELLANEOUS,
		shortname: "Misc.",
		color: VesselColour.LIGHTRED,
		contains: [
			"Miscellaneous",
			"Waste",
			"Tug",
			"Trawler",
			"Trans Shipment Vessel",
			"Training Ship",
			"Tender",
			"Survey Vessel",
			"Stern Trawler",
			"Research",
			"Rescue Vessel",
			"Power Station Vessel",
			"Pontoon",
			"Pipe",
			"Pilot Vessel",
			"Patrol Vessel",
			"Oil Fighting Vessel",
			"Ice Breaker",
			"Fishing Factory Stern Trawler",
			"Factory Ship",
			"Dredger",
			"Deck Cargo",
			"C02 Carrier",
			"Barge"
		]
	},
	[VesselTypeCategory.OFFSHORE]: {
		name: VesselTypeCategory.OFFSHORE,
		shortname: "Offshore",
		color: VesselColour.MAGENTA,
		contains: [
			"Offshore",
			"Utility Vessel",
			"Tug/Supply Ship",
			"Supply Survey Support",
			"Supply Ship Fire Fighting",
			"Supply Ship",
			"Standby Vessel",
			"Self-elevating Unit",
			"Research Survey",
			"Platform Supply Vessel",
			"Offshore Support Vessel",
			"Multi-Purpose Supply Vessel",
			"Multicat",
			"Mining",
			"Loading Buoy",
			"Landing Craft",
			"Floating Storage & Offloading",
			"Floating Production Storage & Offloading",
			"Fishery Research",
			"Drilling Ship",
			"Diving Support Vessel",
			"Crew Transfer Vessel",
			"Crew Tender",
			"Column-stabilised Unit",
			"Cable Laying Vessel",
			"Anchor Handling Tug/Supply",
			"Anchor Handling Tug",
			"Accommodation Work Barge",
			"Accommodation"
		]
	},
	[VesselTypeCategory.PASSENGER_SHIP]: {
		name: VesselTypeCategory.PASSENGER_SHIP,
		shortname: "Passenger",
		color: VesselColour.ORANGE,
		contains: [
			"Passenger Ship",
			"Flotel",
			"Cruise"
		]
	},
	[VesselTypeCategory.PURE_CAR_CARRIER]: {
		name: VesselTypeCategory.PURE_CAR_CARRIER,
		shortname: "Car Crr.",
		color: VesselColour.PURPLE,
		contains: [
			"Pure Car Carrier",
			"Vehicles"
		]
	},
	[VesselTypeCategory.REEFER]: {
		name: VesselTypeCategory.REEFER,
		shortname: "Reefer",
		color: VesselColour.SALMON,
		contains: [
			"Reefer",
			"Fish Carrier"
		]
	},
	[VesselTypeCategory.ROLLON_ROLLOFF]: {
		name: VesselTypeCategory.ROLLON_ROLLOFF,
		shortname: "Ro-Ro",
		color: VesselColour.VIOLET,
		contains: [
			"Roll-on Roll-Off",
			"Passenger",
			"Ferry",
			"Containership"
		]
	},
	[VesselTypeCategory.TANKER]: {
		name: VesselTypeCategory.TANKER,
		shortname: "Tkr.",
		color: VesselColour.YELLOW,
		contains: [
			"Tanker",
			"Wine Carrier",
			"Water Carrier",
			"Veg Oil Carrier",
			"Petroleum Product Tanker",
			"Orange/Fruit Juice Carrier",
			"Oil Tanker",
			"Bunkering Vessel"
		]
	}
};
export default VesselTypeCategoryMeta;
